import React, { useMemo } from 'react'

import { useConfig } from './_load/ConfigLoader'
import { useSaveConfig } from './_request/saveConfig'
import Form from '../../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../../packages/kiti/components/form/SubmitBar'
import LevelSection from './sections/LevelSection'

const EditConfigForm = () => {
  const config = useConfig()
  const [onSubmit, { loading, error }] = useSaveConfig()

  const initialstate = useMemo(() => {
    if (!config) return { name: 'automatic_service_orders_distribution' }
    const initialState = { ...config }
    if (config.value?.distance_radius) {
      initialState.value.distance_radius = config.value.distance_radius / 1000
    }
    return initialState
  }, [config])

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={{ ...config, ...initialstate }}>
      <LevelSection />
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditConfigForm
